import React, { FC, useState } from "react";
import Button from "../../components/UI/button/GgButton";
import ArticleForm from "./ArticleForm";
import Modal from "../../components/modal/Modal";
import articleImage from "../../assets/images/article-img1.png";
import { useModal } from "../../customHooks/useModal";
import { IArticle } from "../../models/IArticle";
import parse from "html-react-parser";
import { $public } from "../../http";
import Banner from "../banner";
import Articles from "../../store/Articles";
import { showLoadingToast, showSuccessToast } from "../../components/toasts";

interface IItemArticle {
  item: IArticle;
  Article: Articles;
  page?: number;
  actionData?: any
}

const Article: FC<IItemArticle> = ({ item, Article, page, actionData }) => {
  const modal = useModal();

  function handleDelete() {
    if (window.confirm("Are you sure you want to delete this article !")) {
      showLoadingToast("Deleting Article ...")
      Article.deleteOne(item, page).then(() => {
        showSuccessToast("Article Deleted Successfully");
      })
    }
  }

  function handleRecover(){
    if (window.confirm("Are you sure you want to Recover this article ?")) {
      showLoadingToast("Recover Article...")
      Article.deleteOne(item, page).then(() => {
        showSuccessToast("Article Recover Successfully");
      })
    }
  }

  return (
    <div className="article">
      <div className="image">
        <img src={$public(item.mainImage)} alt="article" />
      </div>
      <div className="content">
        <div className="title">{item.name}</div>
        <div className="desc">{parse(item.content)}</div>
        {item.status === "deleted" ? 
        (
        <div className="controls">
          <Button label="Recover" onPress={handleRecover} />
        </div>
        ) : (
        <div className="controls">
          {actionData?.edit ? 
        (
          <Button label="Edit" stylesType="border" onPress={modal.openModal} />
        )  : ""
        }
        {actionData?.delete ? 
        (
          <Button label="Delete" onPress={handleDelete} />
        )  : "" }
        </div>
        )}
      </div>
      {/* <Banner /> */}
      <Modal
        title="Edit post"
        show={modal.showModal}
        onClose={modal.setModalShow}
      >
        <ArticleForm
          onClose={modal.closeModal}
          data={{ ...item, banner: item.banner ? "show" : "hidden" }}
          page={page}
          actionData={actionData}
        />
      </Modal>
    </div>
  );
};

export default Article;
